import { render, staticRenderFns } from "./BlockBrowserUrls.vue?vue&type=template&id=3e889f56&scoped=true"
import script from "./BlockBrowserUrls.vue?vue&type=script&lang=js"
export * from "./BlockBrowserUrls.vue?vue&type=script&lang=js"
import style0 from "./BlockBrowserUrls.vue?vue&type=style&index=0&id=3e889f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e889f56",
  null
  
)

export default component.exports